import {
    CREATE_ASANAERROR_POINTS_REQUEST,
    CREATE_ASANAERROR_POINTS_SUCCESS,
    CREATE_ASANAERROR_POINTS_FAILURE,
    CREATE_ASANAERROR_POINTS_FORM,
    FETCH_ASANAERROR_POINTS_REQUEST,
    FETCH_ASANAERROR_POINTS_SUCCESS,
    FETCH_ASANAERROR_POINTS_FAILURE,
    DELETE_ASANAERROR_POINTS_REQUEST,
    DELETE_ASANAERROR_POINTS_SUCCESS,
    DELETE_ASANAERROR_POINTS_FAILURE,
    UPDATE_ASANAERROR_POINTS_REQUEST,
    UPDATE_ASANAERROR_POINTS_SUCCESS,
    UPDATE_ASANAERROR_POINTS_FAILURE,
    FETCH_SINGLE_ASANAERROR_POINTS_REQUEST,
    FETCH_SINGLE_ASANAERROR_POINTS_SUCCESS,
    FETCH_SINGLE_ASANAERROR_POINTS_FAILURE,
    RESET_ASANAERROR_POINTS_INFO,
    NAVIGATE_ASANAERROR_POINTS_DETAILS,
    NAVIGATE_ASANAERROR_POINTS,
    UPDATE_ASANAERROR_POINTS_FORM
} from './asanaErrorPoints.actionsType';

export const ASANAERROR_POINTS = 'asanaErrorPoints';

let initialState = {
    loading: false,
    asanaErrorPoints: [],
    asanaErrorPointsform: {},
    selectedState: {},
    errorMessage: '',
    singleFeedback: {},
    isPartyDetails: false
};

export let asanaErrorPointsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ASANAERROR_POINTS_REQUEST:
        case CREATE_ASANAERROR_POINTS_REQUEST:
        case UPDATE_ASANAERROR_POINTS_REQUEST:
        case FETCH_SINGLE_ASANAERROR_POINTS_REQUEST:
        case DELETE_ASANAERROR_POINTS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ASANAERROR_POINTS_SUCCESS:
            return {
                ...state,
                loading: false,
                asanaErrorPoints: updatePayload
            };
        case CREATE_ASANAERROR_POINTS_SUCCESS:
            return {
                ...state,
                loading: false,
                asanaErrorPointsform: {}
            };
        case UPDATE_ASANAERROR_POINTS_SUCCESS:
            return {
                ...state,
                loading: false,
                asanaErrorPointsform: {}
            };
        case RESET_ASANAERROR_POINTS_INFO:
            return {
                ...state,
                asanaErrorPointsform: {}
            };
        case CREATE_ASANAERROR_POINTS_FORM:
        case UPDATE_ASANAERROR_POINTS_FORM:
            return {
                ...state,
                loading: false,
                asanaErrorPointsform: {
                    ...state.asanaErrorPointsform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_ASANAERROR_POINTS_FAILURE:
        case CREATE_ASANAERROR_POINTS_FAILURE:
        case UPDATE_ASANAERROR_POINTS_FAILURE:
        case FETCH_SINGLE_ASANAERROR_POINTS_FAILURE:
        case DELETE_ASANAERROR_POINTS_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_ASANAERROR_POINTS_DETAILS:
            return {
                ...state,
                isPartyDetails: true,
                singleFeedback: payload.singleFeedback
            };
        case NAVIGATE_ASANAERROR_POINTS:
            return {
                ...state,
                isPartyDetails: false
            };
        default:
            return state;
    }
};
